import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export class DateUtil {
	public static readonly FORMAT_YYYY_MM_dd_hh_mm_A: string = 'YYYY-MM-DD hh:mm A';
	public static readonly FORMAT_yyyy_MM_dd: string = 'YYYY-MM-dd';

	static formatDate(date: Date | string, format: string = DateUtil.FORMAT_YYYY_MM_dd_hh_mm_A): string {
		return dayjs(date).format(format);
	}

	static stringToDate(dateString: string, format?: string): Date | null {
		const parsed = format
			? dayjs(dateString, format, true)
			: dayjs(dateString);
		return parsed.isValid() ? parsed.toDate() : null;
	}
}
